jQuery(document).ready(function($){
  var Shopify = Shopify || {};
  Shopify.money_format = "${{amount}}";

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
      
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  $(window).on('scroll', function(){
      if ($(window).scrollTop() > 60){
          $('body').addClass('float_active');
      }else {
          $('body').removeClass('float_active');
      }
  });

  $(document).on('click', '#menu_trigger', function(event){
      event.preventDefault();
   
      if($('body').hasClass('menu_open')){
          $('body').removeClass('menu_open');
      }else{
          $('body').addClass('menu_open');
      }
  });

  $('.smooth_scroll').click(function(event){
  	event.preventDefault();
  	var margintop = $(this).data('mtop') ? $(this).data('mtop') : 60;
  	
  	if($(this.hash).length > 0){
  		$('html,body').animate({scrollTop:$(this.hash).offset().top - margintop}, 1200);
  	}else{
  		var getUrl = window.location,
  			url = getUrl .protocol +'//'+ getUrl.host +'/'+this.hash;
  		window.location = url;
  	}
  });

  //mobile_menu_overlay
   $(document).on('click', '#mobile_menu_overlay', function(event){
      $('body').removeClass('menu_open');
  });

  const testimonials_carousel = new Swiper('.testimonials_carousel', {
      pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
      },
      breakpoints: {
          0: {
              slidesPerView: 1,
              spaceBetween: 20
          },
          992: {
              slidesPerView: 3,
              spaceBetween: 20
          }
      }
  });

  const corporate_testimonials_carousel = new Swiper('.corporate_testimonials_carousel', {
      pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
      },
      breakpoints: {
          0: {
              slidesPerView: 1.4,
              spaceBetween: 10
          },
          992: {
              slidesPerView: 3.2,
              spaceBetween: 10
          }
      }
  });

  var  product_gallery_slider = new Swiper('.product_gallery_slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
          nextEl: '.product_gallery_nav_next',
          prevEl: '.product_gallery_nav_prev',
      },
  });
  
  const gallery_carousel = new Swiper('.gallery_carousel', {
      centeredSlides: true,
      initialSlide:2,
      spaceBetween: 15,
      loop:true,
      autoplay: {
          delay: 5000,
      },
      navigation: {
          prevEl: '.gallery_carousel_prev',
          nextEl: '.gallery_carousel_next',
      },
      breakpoints: {
          0: {
              slidesPerView: 1.5,
          },
          992: {
              slidesPerView: 3.4,
          }
      }
  });

  //data-thumb
  $(document).on('click', '[data-thumb]', function(event){
    var idx = $(this).data('thumb'),
        slider = $(this).data('slider');

    $('.gallery_thumbnails_wrapper .product_gallery_item').removeClass('active');
    $(this).children('.product_gallery_item').addClass('active');
    $(slider)[0].swiper.slideTo(idx, 300);
  });

  //product_gallery_thumbnails
  const product_gallery_thumbnails = new Swiper('.product_gallery_thumbnails', {
      slidesPerView: 4,
      spaceBetween: 20
  });

  //data-show-complete-team
  $(document).on('click', '[data-show-complete-team]', function(event){
    $('.d-none.toggle_item').removeClass('d-none');
    $(this).closest('.row').addClass('d-none');
  });

  if (typeof variants != 'undefined' && $('[data-image]').length > 0) {
    var variation_image_arr = {};
    $.each(variants, function(idx, variation_data){
      variation_image_arr[variation_data.option1] = variation_data.featured_image.src;
    });
    
    $('[data-image]').each(function(idx, varition_key){
      var key = $(this).data('image');
      $(this).attr('src', variation_image_arr[key]);


    });
  }

  //product_featured_item
  $(document).on('click', '.product_featured_item', function(event){
    $('.product_featured_item').removeClass('active');
    $(this).addClass('active');
  });  

  //qty_plus
  $(document).on('click', '.product_qty_plus', function(event){
    var input = $(this).closest('.qty_wrapper').find('input'),
        v = $(input).val(),
        max = $(input).attr('max');

    max = typeof max != 'undefined' ? max : 10;
    v++;

    if(v >= max) return;

    $(input).val(v).change();
  });
  
  $(document).on('click', '.product_qty_minus', function(event){
    var input = $(this).closest('.qty_wrapper').find('input'),
        v = $(input).val(),
        min = 1;

    v--;

    if(v < min) return;

    $(input).val(v).change();
  });

  //cart_qty_button
  $(document).on('click', '.cart_qty_button, .remove_button', function(event){
    $('.cart__footer').addClass('loading');
    
    setTimeout(()=>{
      var total = 0;
      $('[data-item-total]').each(function(idx, el){
        var price = $(this).data('item-total');
        total = currency(total).add(price);
      });
      
      $('.totals__total-value').text(currency(total).format() +' USD');
      $('.cart__footer').removeClass('loading');
    }, 1000);
  });
  
  //data-active-bullet
  $(document).on('click', '[data-active-bullet]', function(event){
    $('.featured_bullet').removeClass('active');
    var bullet = $(this).data('active-bullet');
    $('.product_features_center_image').addClass('bullet_is_active');
    $('[data-bullet="'+ bullet +'"]').addClass('active');
  }); 

  //data-variation-idx
  $(document).on('click', '[data-variation-idx]', function(event){
    var v_gallery = $(this).val().toLowerCase(),
        v_idx = $(this).data('variation-idx'),
        selected_var = variants[(v_idx - 1)];

    $('.variant_gallery_main').hide();
    $('#gallery_variant_'+ v_gallery).fadeIn();
    
    $('.variant_gallery').hide();
    $('#thumbs_variant_'+ v_gallery).fadeIn();

    $('#thumbs_variant_'+ v_gallery +' .product_gallery_item').removeClass('active');
    $('#thumbs_variant_'+ v_gallery).find('[data-thumb="0"]').click();
    $('#thumbs_variant_'+ v_gallery).find('[data-thumb="0"]').children('.product_gallery_item').addClass('active');

    $('#product_price').html(Shopify.formatMoney(selected_var.price));
    $('#product_id').val(selected_var.id).change();
  });

  //pop_video
  $('.pop_video').magnificPopup({
  	type: 'iframe'
  });

  //pop_gallery
   $('.popup_gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
          enabled:true
      }
  });
  
  $(document).on('click', '.pop_gallery', function(event){
    event.preventDefault();
    var gallery_id = $(this).attr('href');
    $(gallery_id).find('a:first-child').click();    
  });

  //POP UP WINDOW
  $('.open_popup').click(function(event){
  	event.preventDefault();
  	
  	var url = $(this).attr('href') ? $(this).attr('href') : false;
  	var title = $(this).data('title') ? $(this).data('title') : '';
  	var w = $(this).data('popup-width') ? $(this).data('popup-width') : 500;
  	var h = $(this).data('popup-height') ? $(this).data('popup-height') : 400;
  	
  	var left = (screen.width / 2) - (w / 2);
  	var top = (screen.height / 2) - (h / 2);
  	
  	if(!url) return false;
  	
  	return window.open(url, title, 'toolbar=no, copyhistory=no, width='+ w +', height='+ h +', top='+ top +', left='+ left);
  });

  //accordeon_item_header
  $(document).on('click', '.accordeon_item_header', function(event){
    var item = $(this).closest('.accordeon_item'),
        body = $(item).find('.accordeon_item_body');

    if($(item).hasClass('open')){
      $(item).removeClass('open');
      $(body).slideUp();
    }else{
      $(item).addClass('open');
      $(body).slideDown();
    }
  });

  //logos-marquee-slider
  $('.nh-logos-marquee-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 6,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: false,
    cssEase: 'linear',
    speed: 11000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  var window_width = $(window).width();
  const nh_testimonials_carousel = new Swiper('.nh-testimonials-carousel__swiper', {
    slidesPerView: 2.5,
    spaceBetween: 30,
    slidesOffsetBefore: window_width > 1170 ? ( $(window).width() - 1140 ) / 2 : 15,
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 2.8,
        spaceBetween: 30
      }
    }
  });

  //sub-menu-trigger
  $(document).on('click', '.sub-menu-trigger', function(event){
    event.preventDefault();

    var li_parent = $(this).closest('li');
    var submenu = li_parent.find('.sub-menu');

    if(li_parent.hasClass('active')){
      li_parent.removeClass('active');
      submenu.slideUp();
    }else{
      li_parent.addClass('active');
      submenu.slideDown();
    }
  });

  // Dynamic Yotpo reviews count -> updates .rating_count_text
  // Tries to read text like "Based on 81 reviews" from .yotpo-bottom-line-basic-text
  // and writes "(81 Reviews)" into .rating_count_text
  function setRatingCountFromYotpo(){
    var $yotpoText = $('.yotpo-bottom-line-basic-text');
    if ($yotpoText.length === 0) return false;

    var rawText = $.trim($yotpoText.text());
    // Prefer patterns like "81 review(s)", fallback to first number found
    var match = rawText.match(/(\d+)\s+review/i) || rawText.match(/(\d+)/);
    if (!match || !match[1]) return false;

    var count = match[1];
    var $target = $('.rating_count_text');
    if ($target.length === 0) return false;

    $target.text('(' + count + ' Reviews)');
    return true;
  }

  // Dynamic Yotpo rating score -> updates .rating_count_value
  // Reads number like "4.8" from .yotpo-bottom-line-score and writes into .rating_count_value
  function setRatingScoreFromYotpo(){
    var $scoreEl = $('.yotpo-bottom-line-score');
    if ($scoreEl.length === 0) return false;

    var rawText = $.trim($scoreEl.text());
    var match = rawText.match(/\d+(?:\.\d+)?/);
    if (!match || !match[0]) return false;

    var score = match[0];
    var $target = $('.rating_count_value');
    if ($target.length === 0) return false;

    $target.text(score);
    return true;
  }

  // Run immediately and then poll briefly to handle async Yotpo render
  var yotpoCountDone = setRatingCountFromYotpo();
  var yotpoScoreDone = setRatingScoreFromYotpo();
  var yotpoTries = 0;
  var yotpoMaxTries = 40; // ~10s at 250ms
  var yotpoInterval = setInterval(function(){
    var countDone = yotpoCountDone || setRatingCountFromYotpo();
    var scoreDone = yotpoScoreDone || setRatingScoreFromYotpo();
    yotpoCountDone = countDone;
    yotpoScoreDone = scoreDone;
    yotpoTries++;
    if ((countDone && scoreDone) || yotpoTries >= yotpoMaxTries) {
      clearInterval(yotpoInterval);
    }
  }, 250);
});